import * as React from "react";
import { useEffect, useState } from "react";
import {
  SettingsAutocomplete,
  SettingsAutoCompleteOption,
} from "./settingsAutocomplete";
import { useClinicContext } from "../../../clinic/ClinicContext";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PanelSelectorProps {
  onSelect: (value: any) => void;
  value: string;
  disableAutoFocus?: boolean;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PanelSelector = ({ ...props }: PanelSelectorProps) => {
  const [panelList, setPanelList] = useState<SettingsAutoCompleteOption[]>(
    null,
  );
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState<SettingsAutoCompleteOption>(null);
  const dao = useClinicContext();

  const getPolicies = async () => {
    setLoading(true);
    const data = await dao.getPanels().then((response) =>
      response.map((p) => ({
        name: p.name,
        value: p.id,
      })),
    );
    setPanelList(data);
    setLoading(false);
  };

  const handleSelect = (newValue: SettingsAutoCompleteOption) => {
    setValue(
      typeof newValue === "object"
        ? newValue
        : {
            value: newValue,
            name: newValue,
          },
    );
    props.onSelect(typeof newValue === "object" ? newValue?.value : newValue);
  };

  useEffect(() => {
    if (!panelList) {
      getPolicies().catch((e) => console.error(e.error));
    }

    if (panelList && props.value && props.value !== value?.value) {
      setValue(
        {
          value: props.value,
          name: panelList.find((c) => c.value === props.value)?.name,
        } || null,
      );
    }
  }, [panelList, props.value]);

  return (
    <SettingsAutocomplete
      onChange={(selValue) => handleSelect(selValue)}
      value={value}
      loading={loading}
      options={panelList || []}
      autoFocus={!props.disableAutoFocus}
      disabled={props.disabled}
      minwidth={220}
      freeSolo={true}
    />
  );
};
